import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesIndexResponseType>(
      "/api/admin_operators/companies",
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsCompaniesIndex = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApisAdminOperatorsCompaniesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesIndex"],
    ({ pageParam }) => {
      return request({ page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
